// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fea026ae","453":"470c3363","732":"68024544","977":"ac561f96"}[chunkId] + ".chunk.js";
};